if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if(this.form){
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      this.CallApIGiftcard();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
          if(document.querySelector('wishlist-item-delete-button')){
            document.querySelector('wishlist-item-delete-button').sendDeleteRequest(response.product_id);
            document.querySelector('wishlist-drawer').removeProductFromSessionStorage(`${response.product_id}`);
            document.querySelector('wishlist-drawer').renderContentFromSessionStorage();
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          const product_card = this.closest('.product-card-wrapper');
          if (product_card) {
            product_card.classList.remove('adding_cart');
            const loadingEl = product_card.querySelector('.quick_add_loading');
            if (loadingEl) loadingEl.classList.add('hidden');
          }
        
          if (this.submitButton) {
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          }
        
          if (this.cart && this.cart.classList.contains('is-empty')) {
            this.cart.classList.remove('is-empty');
          }
        
          const spinner = this.querySelector('.loading-overlay__spinner');
          if (spinner) spinner.classList.add('hidden');
        });

    }

    CallApIGiftcard(){
      if(document.body.classList.contains("matat_gift_card")){

        const url = "https://loccitane-shopify.matat.io/api/gift-card-purchases";
        let $giftAmount = document.querySelector("variant-radios input[type='radio']:checked").value.replace("₪", "").trim();
        let $recipient_name = document.querySelector("input[name='properties[Recipient name]']").value;
        let $recipient_email = document.querySelector("input[name='properties[Recipient email]']").value;
        let $recipient_phone = document.querySelector("input[name='properties[מספר טלפון]']").value;
        let $message = document.querySelector("textarea[name='properties[Message]']").value;
        let $schedule_date = document.querySelector(".time-date-selection input[name='properties[תאריך לוח זמנים]']").value;
        let $schedule_time = document.querySelector(".time-date-selection input[name='properties[קבע זמן]']").value;
        let $scheduled_send_at = `${$schedule_date} ${$schedule_time}`;
        let $customers_id,$customers_email,$customers_phone;
        let $gift_uniq_id = document.querySelector("input[name='properties[_unique_id]']").value;
        let $customer_loged = false;
        let $payload_data = {};

        let $send_timing,$send_sms;
        $send_timing = 'immediately';
        if(document.querySelector(".type-voucher input[name='properties[מועד שליחה]']:checked").value == "מתוזמן"){
          $send_timing = 'scheduled';
        }
        if(document.querySelector("input[name='properties[שיטת משלוח SMS]']").checked){
          $send_sms = true;
        }else{
          $send_sms = false;
        }
        if(document.querySelector(".customers_data")){
          $customer_loged = true
          $customers_id = document.querySelector(".customers_data").getAttribute("data-customerid");
          $customers_email = document.querySelector(".customers_data").getAttribute("data-customeremail");
          $customers_phone = document.querySelector(".customers_data").getAttribute("data-customerphone");
        }

        if($customer_loged){
          if($send_timing == "immediately"){
            $payload_data = {
              store_domain: `${Shopify.shop}`,
              amount: `${$giftAmount}`,
              recipient_name: `${$recipient_name}`,
              recipient_email: `${$recipient_email}`,
              recipient_phone: `${$recipient_phone}`, // Valid Israeli format
              message: `${$message}`,
              send_timing: `${$send_timing}`,
              shopify_customer_id: `${$customers_id}`,
              shopify_customer_email: `${$customers_email}`,
              gift_card_code: `${$gift_uniq_id}`,
              shopify_customer_phone: `${$customers_phone}`,// "immediately" or "scheduled"
              send_sms: $send_sms
            };
          }else{
            $payload_data = {
              store_domain: `${Shopify.shop}`,
              amount: `${$giftAmount}`,
              recipient_name: `${$recipient_name}`,
              recipient_email: `${$recipient_email}`,
              recipient_phone: `${$recipient_phone}`, // Valid Israeli format
              message: `${$message}`,
              send_timing: `${$send_timing}`, // "immediately" or "scheduled"
              scheduled_send_at: `${$scheduled_send_at}`,
              shopify_customer_id: `${$customers_id}`,
              shopify_customer_email: `${$customers_email}`,
              gift_card_code: `${$gift_uniq_id}`,
              shopify_customer_phone: `${$customers_phone}`, // required if scheduled
              send_sms: $send_sms
            };
          }
        }else{
          if($send_timing == "immediately"){
            $payload_data = {
              store_domain: `${Shopify.shop}`,
              amount: `${$giftAmount}`,
              recipient_name: `${$recipient_name}`,
              recipient_email: `${$recipient_email}`,
              recipient_phone: `${$recipient_phone}`, // Valid Israeli format
              message: `${$message}`,
              gift_card_code: `${$gift_uniq_id}`, 
              send_timing: `${$send_timing}`, // "immediately" or "scheduled"
              send_sms: $send_sms
            };
          }else{
            $payload_data = {
              store_domain: `${Shopify.shop}`,
              amount: `${$giftAmount}`,
              recipient_name: `${$recipient_name}`,
              recipient_email: `${$recipient_email}`,
              recipient_phone: `${$recipient_phone}`, // Valid Israeli format
              message: `${$message}`,
              gift_card_code: `${$gift_uniq_id}`,
              send_timing: `${$send_timing}`, // "immediately" or "scheduled"
              scheduled_send_at: `${$scheduled_send_at}`, // required if scheduled
              send_sms: $send_sms
            };
          }
        }

        console.log("payload",$payload_data)

        fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify($payload_data)
        })
          .then(response => {
            if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.json();
          })
          .then(data => {
            let uniq_id = data.data.id;
            document.querySelector(".gift_uniq_id").value = uniq_id;
            // console.log("Success:", data.data.id);
          })
          .catch(error => {
            console.error("Error:", error);
          });

      }
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

function generateCode() {
  const prefix = "GC";

  const randomBlock = () => {
    return Math.random().toString(16).substring(2, 6).toUpperCase();
  };

  return `${prefix}-${randomBlock()}-${randomBlock()}-${randomBlock()}`;
}

// Generate on page load
document.addEventListener("DOMContentLoaded", () => {
  const code = generateCode();
  if(document.querySelector(".gift_uniq_id")){
    document.querySelector(".gift_uniq_id").value = code;
  }
});